"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNumber = exports.NavigationButtonWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.NavigationButtonWrapper = components_core_1.styled.div `
  ${(props) => props.hideOnMobile
    ? `@media (max-width: ${components_core_1.Breakpoints.b560}px) {
            display: none;
        }`
    : ''}
`;
exports.PageNumber = components_core_1.styled.div `
${(props) => props.hideOnMobile
    ? `@media (max-width: ${components_core_1.Breakpoints.b560}px) {
          margin: auto;
      }`
    : ''}

`;
